import Images from "@Theme/Images";
import Styles from "./styles.module.scss";
import { getListFAQ } from "@Hooks/getListFAQ";
import Icon from "@Atom/Icon";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function FAQSection() {
  const data = getListFAQ()?.slice(0, 5);

  const [selectedItem, setSelectedItem] = useState(null);

  const navigate = useNavigate();

  return (
    <div className={Styles.container}>
      <div className={Styles.images}>
        <img src={Images.FAQ} alt="" />
      </div>

      <div className={Styles.FAQSection}>
        <div className={Styles.header}>
          <span className={Styles.h1}>Frequently Asked Questions</span>
          <div className={Styles.line}></div>
          <span className={Styles.desc}>
            Punya pertanyaan tentang proses rekrutmen di Kerja 365? Jika belum
            menemukan jawabannya, yuk cek dokumentasi lengkap kami{" "}
          </span>

          <div className={Styles.button}>
            <button
              onClick={() => {
                navigate(`/faq`);
              }}
            >
              Lihat lebih banyak
            </button>
          </div>
        </div>

        <div className={Styles.listFAQ}>
          {data?.map((question, idx) => {
            return (
              <div
                key={idx}
                className={`${Styles.list} ${
                  selectedItem?.id === question?.id && Styles.active
                }`}
                onClick={() => {
                  if (selectedItem?.id !== question?.id) {
                    setSelectedItem(question);
                  } else {
                    setSelectedItem(null);
                  }
                }}
              >
                <div className={Styles.question}>
                  <span>{question?.question || "-"}</span>
                  <div>
                    <Icon
                      icon={
                        selectedItem?.id === question?.id
                          ? "arrow-up"
                          : "arrow-down"
                      }
                      size={24}
                      color={""}
                    />
                  </div>
                </div>

                <div
                  className={`${Styles.bottom} ${
                    selectedItem?.id === question?.id ? Styles.show : ""
                  }`}
                >
                  {question?.answers?.map((item, i) => (
                    <span key={i}>
                      {question?.answers?.length > 1 && (
                        <div className={Styles.dot}></div>
                      )}
                      <span className={Styles.label}>{item?.label || "-"}</span>
                    </span>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
